import { MODALS } from '@/context'
import { useModal, useTranslator } from '@/hooks'
import { TypeLang } from '@/schema'
import { designGrid, mq } from '@/styles'
import { CONTACT_INFORMATION_TRANSLATION } from '@/utils'
import { useParams } from 'next/navigation'
import { useCallback } from 'react'
import styled from 'styled-components'
import { COMPANY_LINKS } from './Footer'

const headingId = 'prefooter'
export const AsidePreFooter = () => {
  const { lang } = useParams() as { lang: TypeLang }
  const { t } = useTranslator()
  const { toggle:toggleModalContact } = useModal(MODALS.CONTACT)

  const onClickContact = useCallback(() => {
    toggleModalContact()
  }, [toggleModalContact])

  return (
    <Aside>
      <h2 id={headingId} className='srt-only'>{CONTACT_INFORMATION_TRANSLATION[lang]}</h2>
      <article>
        <div className='media-wrapper'>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img className='media' src='/images/prefooter--left.png' alt='Background image' />
        </div>
        <svg xmlns='http://www.w3.org/2000/svg' width='54' height='50' viewBox='0 0 54 50' fill='none'
          stroke='#fff' strokeWidth='3' strokeLinejoin='round'><path d='M4.05 27.39a17.2 17.2 0 0 1-1.63-11.91c.91-4.04 3.24-7.62 6.57-10.08s7.44-3.66 11.58-3.35 8.03 2.08 10.96 5.01 4.72 6.81 5.02 10.93a17.2 17.2 0 0 1-3.36 11.55 17.3 17.3 0 0 1-10.11 6.55c-4.05.9-8.29.33-11.95-1.62l-6.67 1.96c-.33.1-.68.1-1.02.02s-.64-.26-.88-.5-.42-.55-.5-.88-.08-.68.02-1.01l1.97-6.64z' /><path d='M35.64 13.52c2.91.16 5.73 1.04 8.2 2.58s4.52 3.66 5.94 6.19a17.2 17.2 0 0 1 .17 16.6l1.96 6.65c.1.33.1.68.02 1.01s-.26.64-.5.88-.55.42-.88.5-.69.08-1.02-.02l-6.66-1.96c-2.2 1.17-4.63 1.86-7.12 2.01s-4.99-.24-7.31-1.14a17.3 17.3 0 0 1-6.17-4.08c-1.74-1.79-3.07-3.93-3.89-6.28' strokeLinecap='round' /></svg>
        <h3>{t('project.prefooter.text_left')}</h3>
        <div>
          <button className='btn' onClick={onClickContact}>
            <span>{t('contact_us')}</span>
          </button>
        </div>
      </article>
      <article>
        <div className='media-wrapper'>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img className='media' src='/images/prefooter--right.jpg' alt='Background image' />
        </div>
        <svg xmlns='http://www.w3.org/2000/svg' width='54' height='54' viewBox='0 0 54 54' fill='none'><path d='M27 20c2.12 0 3.85-1.79 3.85-4s-1.72-4-3.85-4-3.85 1.79-3.85 4 1.72 4 3.85 4z' fill='#fff' /><g stroke='#fff' strokeWidth='3' strokeLinejoin='round'><path d='M40.46 16C40.46 30 27 38 27 38s-13.46-8-13.46-22a14.3 14.3 0 0 1 3.94-9.9A13.2 13.2 0 0 1 27 2a13.2 13.2 0 0 1 9.52 4.1 14.3 14.3 0 0 1 3.94 9.9z' /><path d='M44.31 34.79C49.05 36.61 52 39.17 52 42c0 5.52-11.19 10-25 10S2 47.52 2 42c0-2.84 2.95-5.39 7.69-7.21' strokeLinecap='round' /></g></svg>
        <h3>{t('project.prefooter.text_right')}</h3>
        <div>
          <a className='btn' href={COMPANY_LINKS.googleMaps} target='_blank' rel='noopener noreferrer' aria-label={`${'Google maps'} (Opens in new tab)`}>
            <span>{t('project.see_map')}</span>
          </a>
        </div>
      </article>
    </Aside>
  )
}

const Aside = styled.aside`
  ${designGrid({})}
  margin-bottom: 50px;
  padding-top: 75px;
  width: 100vw;
  width: 100dvw;

  ${mq.greaterThan('tablet')} {
    padding-top: 110px;
  }

  article {
    align-items: center;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    grid-column: 1 / span 6;
    min-height: 240px;
    justify-content: center;
    overflow: hidden;
    padding: 40px 30px;
    position: relative;

    ${mq.greaterThan('tablet')} {
      flex-shrink: 0;
      gap: 30px;
      grid-column: auto / span 6;
      min-height: 506px;
      padding: 0 80px;
    }

    &:nth-of-type(1) {
      h3 {
        padding: 0 20px;
      }

      ${mq.lessThan('tablet')} {
        margin-bottom: 30px;
      }

      /* .media-wrapper {
        backdrop-filter: blur(147px);
      } */
    }

    &:nth-of-type(2) {
      h3 {
        padding: 0 15px;
      }
      /* .media-wrapper {
        backdrop-filter: blur(100px);
      } */
    }

    .media-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: -1;

      .media {
        height: 100%;
        width: 100%;
        object-fit: cover;
        object-position: center;
        transition: filter 250ms ease;
        /* filter: blur(10px); */
      }
    }
  }

  h3 {
    color: var(--color-white);
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 20px */
    max-width: 310px;
    padding: 0 10px;

    ${mq.greaterThan('tablet')} {
      font-size: 35px;
      max-width: 510px;
    }
  }

  .btn {
    align-items: center;
    background-color: var(--color-gold);
    border-radius: 100px;
    border: 1px solid var(--color-gold);
    display: flex;
    gap: 10px;
    justify-content: center;
    padding: 12px 20px;
    transition: background-color 250ms ease, border-color 250ms ease;

    ${mq.greaterThan('tablet')} {
      padding: 15px 30px;
    }

    &:hover {
      background-color: var(--color-black);

      span {
        color: var(--color-gold);
      }
    }

    span {
      color: var(--color-black);
      font-size: 13px;
      font-style: normal;
      font-weight: 500;
      line-height: 115%; /* 14.95px */
      transition: background-color color 250ms ease;

      ${mq.greaterThan('tablet')} {
        font-size: 15px;
      }
    }
  }
`
